<template>
  <span v-if="shipping.eta" class="shipping-eta-source">
    <font-awesome-icon v-if="withSource" :icon="sourceIcon" v-b-tooltip.hover :title="sourceTitle" class="ml-1" />
    <span v-if="isOutdated" class="ml-1 text-danger" v-b-tooltip.hover :title="lastPositionTitle">(*)</span>
  </span>
</template>

<script>
// Above this many minutes the tracking position that produced the ETA is flagged
// as outdated. Kept in sync with the mark the Delivery Date Monitor used inline.
const OUTDATED_TRACKING_MINUTES = 10

export default {
  name: 'ShippingsEtaSource',
  props: {
    shipping: {
      type: Object,
      required: true
    },
    withSource: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    sourceIcon() {
      return this.shipping.etaType === 'item' ? 'trailer' : 'truck-moving'
    },
    sourceTitle() {
      return this.shipping.etaType === 'item'
        ? this.$gettext('Calculated from item position')
        : this.$gettext('Calculated from courier position')
    },
    isOutdated() {
      if (!this.shipping.etaUpdateDate) return false
      const minutes = this.moment.duration(this.moment.utc().tz(this.$tz) - this.moment.utc(this.shipping.etaUpdateDate).tz(this.$tz)).asMinutes()
      return minutes > OUTDATED_TRACKING_MINUTES
    },
    lastPositionTitle() {
      return this.$gettextInterpolate(this.$gettext('Last tracking sent on %{date}'), {
        date: this.moment.utc(this.shipping.etaUpdateDate).tz(this.$tz).format('L LT')
      })
    }
  }
}
</script>

<style lang="scss">
.shipping-eta-source {
  white-space: nowrap;
}
</style>
